
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conjure",
      function () {
        return require("private-next-pages/conjure/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conjure"])
      });
    }
  